export default {
    openToNewWindow(event, height, width) {
        let target = event.currentTarget;
        window.open(target.href, target.innerText, 'width=' + width + ', height=' + height + ', scrollbars=1');
        event.preventDefault();
    },

    isFireFox() {
        return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
};



/** WEBPACK FOOTER **
 ** ./frontend/js/utils/helper.js
 **/